import { styled } from 'styled-components';

import CommonIcon from '../Icon';

export const RecurringIcon = styled(CommonIcon)`
  background-color: var(--color-background-avatar);
  border-radius: var(--border-radius-tiny);
  padding: var(--spacing-tiny);
`;
